import React, { useEffect, useRef } from 'react';

export default function LazyloadImage({ source, placeholder, className, ...props }) {
  const imgRef = useRef(null);
  const isFirstRenderRef = useRef(true);
  const placeholderSrc = placeholder || "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    // Skip the first render - let lazysizes handle initial loading
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }

    // For any subsequent source changes, load directly
    img.src = source || placeholderSrc;
    img.removeAttribute('data-src');
    img.classList.remove('lazyload');
  }, [source, placeholderSrc]);

  return (
    <img
      ref={imgRef}
      src={ placeholderSrc }
      data-src={ source }
      className={ `${className ? className : ''} lazyload` }
      { ...props }
    />
  );
}